 <template>
  <div class="section-box" style="    padding: 20px 10px;">
    <el-form ref="searchForm" inline label-width="90px">
      <el-form-item label="时间：">
        <!-- <el-input size="medium" style="width:150px;" v-model="form.spaperNo" placeholder="请输入考试编号" type="text" /> -->
          <el-date-picker
          size=""
          v-model="searchTime"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="—"
          start-placeholder="开始日期"
          end-placeholder="结束日期" 
          style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"  @click="reloadData" >查询</el-button >
      </el-form-item>
    <!-- <div class="btn"> 
      <el-button type="primary" icon="el-icon-refresh-right" @click="reloadData" >刷新</el-button >
    </div> -->
    </el-form>
    <!-- B2B统计数据 -->
    <el-table
      :data="b2bTableData"
      :span-method="objectSpanMethod"
      :border="true"
      v-loading="listLoading"
      stripe
      style="width: 100%"
    >
      <el-table-column prop="Platform" label="平台" width="100">
      </el-table-column>
      <el-table-column prop="JobType" label="工单类别" width="150">
      </el-table-column>

      <el-table-column prop="JobCount" label="今日发单数量" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'" style="text-decoration: underline;cursor: pointer;" @click="viewSendJob(6)">  
             {{scope.row.JobCount}}
          </span>
          <span v-else>  
             {{scope.row.JobCount}}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="JobMatchCompleteCount"
        label="今日匹配完成数量"
        width="150"
      >
      <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'" style="text-decoration: underline;cursor: pointer;" @click="viewJobMatchComplete()">  
             {{scope.row.JobMatchCompleteCount}}
          </span>
          <span v-else>  
             {{scope.row.JobMatchCompleteCount}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="JobMatchingCount"
        label="今日匹配中工单数量"
        width="150"
      >
      <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'" style="text-decoration: underline;cursor: pointer;" @click="viewJobMatching()">  
             {{scope.row.JobMatchingCount}}
          </span>
          <span v-else>  
             {{scope.row.JobMatchingCount}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="JobWaitPayCount"
        label="今日待付款工单数量"
        width="150"
      >
      <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'" style="text-decoration: underline;cursor: pointer;" @click="viewWaitPayJob(6)">  
             {{scope.row.JobWaitPayCount}}
          </span>
          <span v-else>  
             {{scope.row.JobWaitPayCount}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="JobHangUpCount" label="今日挂起工单数量">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'" style="text-decoration: underline;cursor: pointer;" @click="viewHangUpJobJob()">  
             {{scope.row.JobHangUpCount}}
          </span>
          <span v-else>  
             {{scope.row.JobHangUpCount}}
          </span>
        </template> 
      </el-table-column>
    </el-table>

      <!-- 众包统计数据 -->
    <el-table
      class="freeTable"
      :data="freeTableData"
      :span-method="objectSpanMethod"
      v-loading="listLoading"
      :border="true"
      stripe
      style="width: 100%"
    >
      <el-table-column prop="Platform" label="平台" width="100">
      </el-table-column>
      <el-table-column prop="JobType" label="工单类别" width="150">
      </el-table-column>
      <el-table-column prop="JobCount" label="今日发单数" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'" style="text-decoration: underline;cursor: pointer;" @click="viewSendJob(1)">  
             {{scope.row.JobCount}}
          </span>
          <span v-else>  
             {{scope.row.JobCount}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="JobWaitPayCount" label="待支付" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'||scope.row.JobType=='合计金额'" style="text-decoration: underline;cursor: pointer;" @click="viewWaitPayJob(1)">  
             {{scope.row.JobWaitPayCount}}
          </span>
          <span v-else>  
             {{scope.row.JobWaitPayCount}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="JobInfoAmount" label="支付信息费" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'||scope.row.JobType=='合计金额'" style="text-decoration: underline;cursor: pointer;" @click="viewPayInfoAmountJob()">  
            {{scope.row.JobInfoAmount}}
          </span>
          <span v-else>  
            {{scope.row.JobInfoAmount}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="PushMsgProp" label="一键推送" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'||scope.row.JobType=='合计金额'" style="text-decoration: underline;cursor: pointer;" @click="viewPropAmountJob(5)">  
            {{scope.row.PushMsgProp}}
          </span>
          <span v-else>  
            {{scope.row.PushMsgProp}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="UrgentProp" label="急单道具" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'||scope.row.JobType=='合计金额'" style="text-decoration: underline;cursor: pointer;" @click="viewPropAmountJob(1)">  
            {{scope.row.UrgentProp}}
          </span>
          <span v-else>  
            {{scope.row.UrgentProp}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="PoolTop3Prop" label="3天置顶道具" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'||scope.row.JobType=='合计金额'" style="text-decoration: underline;cursor: pointer;" @click="viewPropAmountJob(3)">  
            {{scope.row.PoolTop3Prop}}
          </span>
          <span v-else>  
            {{scope.row.PoolTop3Prop}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="PoolTop1Prop" label="1天置顶道具" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'||scope.row.JobType=='合计金额'" style="text-decoration: underline;cursor: pointer;" @click="viewPropAmountJob(2)">  
            {{scope.row.PoolTop1Prop}}
          </span>
          <span v-else>  
            {{scope.row.PoolTop1Prop}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="DelayPastDueProp" label="延时道具">
        <template slot-scope="scope">
          <span v-if="scope.row.JobType=='合计数量'||scope.row.JobType=='合计金额'" style="text-decoration: underline;cursor: pointer;" @click="viewPropAmountJob(4)">  
            {{scope.row.DelayPastDueProp}}
          </span>
          <span v-else>  
            {{scope.row.DelayPastDueProp}}
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 发单列表 -->
    <SendJobList ref="sendJobListRef" />
    <!-- 匹配完成工单列表 -->
    <MatchCompleteJobList ref="matchCompleteJobListRef" />
     <!-- 匹配中工单列表 -->
     <MatchingJobList ref="matchingJobListRef" />
    <!-- 匹配中工单列表 -->
    <WaitPayJobList ref="waitPayJobListRef" />
    <!-- 挂起工单列表 -->
    <HangUpJobList ref="hangUpJobListRef" />

    <!-- 支付信息费用工单列表 -->
    <PayInfoAmountJobList ref="payInfoAmountJobListRef" />
      <!--道具费用工单列表 -->
    <PropAmountJobList ref="propAmountJobListRef" />
  </div>
</template> 
 <script>
import {
  getJobDayStatisticalData, //获取统计数据
} from "@/service/jobStatistics";
import SendJobList from "./index/sendJobList.vue";
import MatchCompleteJobList from "./index/matchCompleteJobList.vue";
import MatchingJobList from "./index/matchingJobList.vue";
import WaitPayJobList from "./index/waitPayJobListV.vue";
import HangUpJobList from "./index/hangUpJobList.vue";
import PayInfoAmountJobList from "./index/payInfoAmountJobList.vue";
import PropAmountJobList from "./index/propAmountJobList.vue";
export default {
  components: {
    SendJobList,
    MatchCompleteJobList,
    MatchingJobList,
    WaitPayJobList,
    HangUpJobList,
    PayInfoAmountJobList,
    PropAmountJobList
  },
  data() {
    return {
      searchTime:"",
      startTime:"",
      endTime:"",
      listLoading: false,
      b2bTableData: [],
      freeTableData: [],


      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  created() {
    const now = new Date();
   var today= `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
    this.searchTime=[today,today];

    this.getJobStatisticsData();
  },
  methods: {
    reloadData() { 
      this.getJobStatisticsData();
    },
    //设置合并列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        //第一列
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },

    //获取工单统计数据
    async getJobStatisticsData() {
      console.log(" getJobStatisticsData searchTime:"+this.searchTime)
      if(this.searchTime&&this.searchTime.length)
      {
        this.startTime =this.searchTime[0]  ;
        this.endTime= this.searchTime[1]  ;
      }
      console.log("this.startTime:"+this.startTime);
      console.log("this.endTime:"+this.endTime);
      
      this.listLoading = true;
      let data = {
        StartDate:this.startTime,
        EndDate:this.endTime
      };
      console.log('data:'+JSON.stringify(data));
      let res = await getJobDayStatisticalData(data);
      setTimeout(() => {
        this.listLoading = false;

        if (res.Result != 1) {
          return this.$message.error("获取失败请联系开发人员");
        }
        this.b2bTableData = res.Data.B2bJobStatisticeList;
        this.freeTableData = res.Data.FreeJobStatisticeList;
        console.log(JSON.stringify(res.Data));
      }, 600);
    },

    //查看今日发单列表
    viewSendJob(jobType) {
      this.$refs.sendJobListRef.openDia(this.startTime,this.endTime,jobType);
    },
    //查看今日匹配完成工单
    viewJobMatchComplete() {
      this.$refs.matchCompleteJobListRef.openDia(this.startTime,this.endTime);
    },
 //查看今日匹配中工单
    viewJobMatching() {
      this.$refs.matchingJobListRef.openDia(this.startTime,this.endTime);
    },
     //查看待支付工单
     viewWaitPayJob(jobType) {
      this.$refs.waitPayJobListRef.openDia(this.startTime,this.endTime,jobType);
    } ,
    //查看挂起工单
    viewHangUpJobJob(jobType) {
      this.$refs.hangUpJobListRef.openDia(this.startTime,this.endTime,jobType);
    },
    //查看支付信息费用工单
    viewPayInfoAmountJob() {
      this.$refs.payInfoAmountJobListRef.openDia(this.startTime,this.endTime);
    },
    //查看道具费用工单  1急单道具；2-1天置顶道具；3-3天置顶道具；4延时道具工单；5一键推送道具；
    viewPropAmountJob(propType) {
      this.$refs.propAmountJobListRef.openDia(this.startTime,this.endTime,propType);
    },
  }
};
</script>
 
 <style lang="scss" scoped >
.section-box {
  background-color: #ffffff;
  padding: 10px;
  min-height: 700px;
  .freeTable {
    margin-top: 20px;
  }
 
}
</style>